module.exports = __webpack_public_path__ + "media/svg/eu-26c14270.svg";